import ModuleMixin from '@/Mixins/ModuleMixin'
import { EventBus } from '@/app'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.mercadoPago',

            MercadoPagoSDK: null
        }
    },

    methods: {
        openWebForm() {
            if(_.get(this.$page.props.request.query, 'open-modal') == 'mercadopago-web-form') {
                this.$Util.loadDynamicResource(
                    'script-mercadopago',
                    'script',
                    'https://sdk.mercadopago.com/js/v2/'
                )
                .then(() => {
                    this.MercadoPagoSDK = new MercadoPago(this.$state.$mercadoPago.server.public_key)

                    EventBus.$emit(
                        'generic.modal.show',
                        'mercadopago-web-form',
                        {
                            title: 'Continuar el proceso de pago con MercadoPago',
                            component: 'mercadopago-web-form',
                            componentProps: {
                                'preference_id': this.$page.props.request.query.preference_id
                            },
                            modalProps: {
                                size: 'md'
                            }
                        }
                    )
                })
                .catch((e) => {
                    console.log('error loadDynamicResource script-mercadopago', e.message)
                })
            }
        }
    },

    created() {
        EventBus.$on('generic.modal.mounted', this.openWebForm)
    }
}
